var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"gridItem",class:{
    'gridItem--hover': _vm.hasHoverState,
    'gridItem--youtube': _vm.isYoutube
  }},[(_vm.hasHoverState)?_c('div',{staticClass:"gridItem__overlay"},[_c('p',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{ref:"inner",staticClass:"gridItem__inner"},[_vm._t("default")],2),_vm._t("downloadIcon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }